<app-header />
<main
  [class.main--chat-fullscreen]="isChatRoute()"
  [class.main--chat-sidebar]="user()?.canAccessChat === true && chatMode() === 'sidebar'">
  @if (isUserLoggedIn()) {
    <app-sidebar [attr.inert]="isChatRoute() ? '' : null" />
  }
  <div
    #mainContent
    cdkScrollable
    class="main-content"
    [class.main-content--hidden]="isChatRoute()"
    [attr.inert]="isChatRoute() ? '' : null">
    <router-outlet></router-outlet>
  </div>
  @if (isUserLoggedIn() && user()?.canAccessChat) {
    <app-chat />
  }
</main>
